import { getImage } from "../../../data";

export const createPanelState = (state) => {
  const panel = {
    header: [],
    body: [],
    footer: [],
  };

  if (!state.context?.tractor?.state) {
    return panel;
  }

  if (state.context.tractor.state.topic) {
    return createTopicPanel(state, panel);
  } else {
    return createTocPanel(state, panel);
  }
};

export const createTocPanel = (state, panel) => {
  const { header, body } = panel || {};

  // Header
  header.push({
    type: "NavBar",
    label: "ui-configuration",
    rightAction: {
      type: "panel/close",
    },
  });

  /* header.push({
    type: "Tabs",
    value: state.context?.tractor?.state?.view,
    options: state.context?.tractor?.property?.view?.options || [],
    action: {
      type: "context/setValue",
      payload: {
        path: "tractor/view",
        value: null,
      },
    },
  }); */

  // Body

  const filteredTopics = state.context?.tractor?.property?.topic.options.filter(
    (item) => {
      return item.properties && item.properties.length && !item.disabled;
    }
  );

  // sorting ???

  // categories ???

  filteredTopics.forEach((topic) => {
    const props = topic.properties || [];

    if (props.length) {
      const prop = state.context?.tractor?.property[props[0]];
      const valueType = prop?.valueType || prop?.type;

      let value = state.context?.tractor?.state[props[0]];

      // use option label if possible
      if (prop.type === "Select") {
        const option = prop.options.find((option) =>
          typeof option === "object" ? option.value === value : option === value
        );

        if (typeof option === "object" && option.label) {
          value = option.label;
        }
      }
      body.push({
        type: "ListItem",
        label: topic.label,
        icon: topic.icon || "(i)",
        value,
        valueType,
        action: {
          type: "context/setValue",
          payload: {
            path: "tractor/topic",
            value: topic.value,
          },
        },
        quickAction: {
          type: "context/toggleValue",
          payload: {
            path: "tractor/" + prop.id
          },
        },
      });
    } else {
      body.push({
        type: "ListItem",
        label: topic.label,
        icon: topic.icon || "(i)",
        action: {
          type: "context/setValue",
          payload: {
            path: "tractor/topic",
            value: topic.value,
          },
        },
      });
    }
  });

  return panel;
};

export const createTopicPanel = (state, panel) => {
  const { header, body } = panel || {};
  const topic = state.context?.tractor?.property?.topic?.options.find(
    (item) => item.value === state.context?.tractor?.state?.topic
  );

  if (!topic) {
    return panel;
  }

  // Header
  header.push({
    type: "NavBar",
    label: topic.label,
    leftAction: topic.properties?.length
      ? {
          type: "context/setValue",
          payload: {
            path: "tractor/topic",
            value: null,
          },
        }
      : null,
    rightAction: {
      type: "panel/close",
    },
  });

  const properties = topic.properties || [];

  properties.forEach((id) => {
    const property = state.context?.tractor?.property[id];

    body.push({
      type: "Label",
      label: property.label || `${property.id}-label`,
    });

    body.push(createPanelItem(state, "tractor", property));

    if (property.options) {
      const selectedOption = property.options.find(
        (option) => option.value === state.context?.tractor?.state[id]
      );
      if (selectedOption?.description) {
        body.push({
          type: "RichText",
          value: selectedOption?.description,
        });
      }
    }
  });

  const image = getImage(topic.value);

  if (image) {
    body.push({
      type: "Image",
      src: image,
    });
  }

  if (topic.description) {
    body.push({
      type: "RichText",
      value: topic.description,
    });
  }

  return panel;
};

export const createPanelItem = (state, key, property) => {
  // BooleanEditor
  if (property.type === "Boolean") {
    return {
      type: "Switch",
      label: property.label || property.id,
      value: state.context[key].state[property.id],
      action: {
        type: "context/setValue",
        payload: {
          path: `${key}/${property.id}`,
          value: !state.context[key].state[property.id],
        },
      },
    };
  }
  // NumberEditor
  if (property.type === "String") {
    return {
      type: "StringEditor",
      label: property.id,
      value: state.context[key].state[property.id],
      action: {
        type: "context/setValue",
        payload: {
          path: `${key}/${property.id}`,
          value: state.context[key].state[property.id],
        },
      },
    };
  }

  // NumberEditor
  if (property.type === "Number") {
    if (isNaN(property.min) || isNaN(property.min) || isNaN(property.step)) {
      return {
        type: "NumberEditor",
        label: property.id,
        value: state.context[key].state[property.id],
        action: {
          type: "context/setValue",
          payload: {
            path: `${key}/${property.id}`,
            value: state.context[key].state[property.id],
          },
        },
      };
    } else {
      return {
        type: "Slider",
        label: property.id,
        value: state.context[key].state[property.id],
        min: property.min,
        max: property.max,
        step: property.step,
        action: {
          type: "context/setValue",
          payload: {
            path: `${key}/${property.id}`,
            value: state.context[key].state[property.id],
          },
        },
      };
    }
  }

  // NumberEditor
  if (property.type === "Select") {
    return {
      type: (property.id === "color" || property.id === "wheelColor") ? "ColorSelector" : "ButtonGroup",
      label: property.id,
      value: state.context[key].state[property.id],
      options: property.options,
      action: {
        type: "context/setValue",
        payload: {
          path: `${key}/${property.id}`,
          value: state.context[key].state[property.id],
        },
      },
    };
  }

  // ColorEditor
  if (property.type === "Color") {
    return {
      type: "ColorEditor",
      label: property.id,
      value: state.context[key].state[property.id],
      action: {
        type: "context/setValue",
        payload: {
          path: `${key}/${property.id}`,
          value: state.context[key].state[property.id],
        },
      },
    };
  }
};
